module.exports = __webpack_public_path__ + "static/img/huabei.ca7323b8.svg";